<div class="marketing-carousel">
  <!-- <carousel
    [height]="110"
    [arrows]="!isMobile"
    [dots]="isMobile"
    tabindex="0"
  >
    <div
      *ngFor="let tile of marketingTiles | async"
      class="carousel-cell"
    >
      <img
        [src]="tile.imagePath"
        [alt]="tile.altText"
      >
    </div>
  </carousel> -->
  <p-carousel [value]="marketingTiles | async" [numVisible]="3" [numScroll]="1" [circular]="false" [responsiveOptions]="primengResponsiveOptions">
    <ng-template let-product pTemplate="item">
        <div class="marketing-item">
          <img
            [src]="product.imagePath"
            [alt]="product.altText"
          >
        </div>
    </ng-template>
  </p-carousel>
  <div class="d-flex justify-content-center pt-3">
    <app-arrow-link
      text="Do Not Sell My Personal Info"
      (handleClick)="openLink('https://www.campbowwow.com/ccpa/')"
    ></app-arrow-link>
  </div>
</div>
